import appApi from "@/app/api";
import { TCloudAPIResponse } from "@/types/app";
import { CHECKOUT_SERVICE_BASE_URL } from "../constants.checkout";

const APIURL = `${CHECKOUT_SERVICE_BASE_URL}/pricing/missing-out`;

interface Option {
  productIds: string[];
  appLang?: string;
  token?: string;
}

interface TMissingFeatureResponse {
  missing_out: string[];
  country: string;
  language: string;
}

type TResponse = TCloudAPIResponse<TMissingFeatureResponse>;

export const getMissingFeature = async (
  option: Option,
): Promise<TMissingFeatureResponse | null> => {
  const { productIds, appLang = "en", token } = option || {};

  const headers = {
    lang: appLang || "en",
    ...(token ? { Authorization: "Bearer " + token } : {}),
  };

  try {
    const response = await appApi.post(
      APIURL,
      {
        product_ids: productIds,
      },
      {
        headers,
      },
    );
    const resData = response.data as TResponse;
    return resData.data;
  } catch (error) {
    console.error("Error fetching missing features:", error);
    return null;
  }
};
